<template>
  <div class="content">
    <!--甲乙信息-->
    <div class="content-box content-party">
      <!-- <el-form
        :model="form"
        ref="form"
        label-position="top"
        :rules="rules"
      > -->
      <div class="form-box">
        <p class="form-title">
          {{ $t('crm_contract_personPart_trial.jia_yi_fang_xin_xi') }}
        </p>
        <el-form :model="form.partnerInfo" ref="formPartnerInfo" label-position="top">
          <div class="form-container">
            <el-row>
              <el-col :span="12" class="party-a">
                <div class="title">
                  <span>{{ $t('crm_contract_personPart_trial.jia_fang_xin_xi') }}</span>
                </div>
                <div class="party-form">
                  <el-form-item :label="$t('crm_contract_personPart_trial.jfsqdb')" prop="partyAName" :rules="rules.partyAName">
                    <el-input v-model="form.partnerInfo.partyANameCode" :disabled="true" style="width: 100%"></el-input>
                  </el-form-item>
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.ye_wu_fu_ze_ren')" prop="salesman" :rules="rules.salesman">
                        <custom-select
                          v-model="form.partnerInfo.salesman"
                          :auto="false"
                          url="roleGetUserList"
                          :listener="`${form.partnerInfo.partyAId || null}`"
                          width="100%"
                          filterable
                          :isDefault="!!isNeedRequest"
                          :props="{ label: 'realName', value: 'realName' }"
                          :params="{ orgId: form.partnerInfo.partyAId, roleCode: 'SYS_ROLE_SM' }"
                          @change="salesmanChange"
                          @getList="getSalesmanList"
                        ></custom-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.ywfzrdh')" prop="salesmanPhone" :rules="rules.salesmanPhone">
                        <el-input v-model="form.partnerInfo.salesmanPhone" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="16">
                    <el-col :span="18">
                      <el-form-item :label="$t('crm_contract_personPart_trial.yin_hang_zhang_hao')" prop="partyADepositNumber" :rules="rules.partyADepositNumber">
                        <custom-select
                          url="crmPartnerBankcardAvailableList"
                          :listener="`${form.partnerInfo.partyAId}${BankcardListFlag}`"
                          v-model="form.partnerInfo.partyADepositNumber"
                          :props="{ label: 'depositNumber', value: 'depositNumber' }"
                          :params="{ bizId: form.partnerInfo.partyAId }"
                          :placeholder="$t('Common.com_please_select')"
                          @change="onDepositNumber"
                          @getList="onGetBankList"
                          width="100%"
                        ></custom-select>
                        <!--  -->
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item label="">
                        <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <el-button style="width: 100%" @click="addBankCard">{{ $t('Common.com_added') }}</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.zhang_hu_ming_cheng')" prop="partyADepositName" :rules="rules.partyADepositName">
                        <el-input v-model="form.partnerInfo.partyADepositName" placeholder="" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.kai_hu_yin_hang')" prop="partyADepositBank" :rules="rules.partyADepositBank">
                        <el-input v-model="form.partnerInfo.partyADepositBank" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item :label="$t('crm_contract_personPart_trial.sqdbdz')" prop="partyAAddress" :rules="rules.partyAAddress">
                    <el-input type="textarea" v-model="form.partnerInfo.partyAAddress" :disabled="true" style="width: 100%"></el-input>
                  </el-form-item>
                </div>
              </el-col>
              <el-col :span="12" class="party-b">
                <div class="title">
                  <span>{{ $t('crm_contract_personPart_trial.yi_fang_xin_xi') }}</span>
                </div>
                <div class="party-form">
                  <el-form-item :label="$t('crm_contract_personPart_trial.yi_fang')" prop="customerId" :rules="rules.customerId">
                    <custom-select
                      ref="customerSelect"
                      v-model="form.partnerInfo.customerId"
                      :auto="false"
                      url="partnerGetCustomerList"
                      :listener="`${form.partnerInfo.customerName}${isNeedRequest}`"
                      filterable
                      remote
                      width="100%"
                      :props="{ label: 'partnerNameCode', value: 'partnerOrgId' }"
                      :params="{ num: 50, keyword: form.partnerInfo.customerName }"
                      @change="partyBChange"
                      @clear="onCustomerClear"
                    ></custom-select>
                  </el-form-item>
                  <el-row :gutter="16">
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.xiang_mu_fu_ze_ren')" prop="projectContactName" :rules="rules.projectContactName">
                        <!-- <el-input v-model="form.partnerInfo.projectContactName" style="width: 100%"></el-input> -->
                        <custom-select
                          v-model="form.partnerInfo.projectContactName"
                          :auto="false"
                          url="partnerContact"
                          :listener="`${form.partnerInfo.customerId || null}`"
                          width="100%"
                          filterable
                          allowCreate
                          defaultFirstOption
                          :isDefault="!!isNeedRequest"
                          :props="{ label: 'contactName', value: 'contactName' }"
                          :params="{ partnerOrgId: form.partnerInfo.customerId, contactType: 'busleader' }"
                          @change="projectContactNameChange"
                        ></custom-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.lian_xi_dian_hua')" prop="projectContactPhone" :rules="rules.projectContactPhone">
                        <el-input v-model="form.partnerInfo.projectContactPhone" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="16">
                    <!-- 暂时没字段 -->
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.shou_quan_dai_biao')" prop="signerName" :rules="rules.signerName">
                        <el-input v-model="form.partnerInfo.signerName" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item :label="$t('crm_contract_personPart_trial.lian_xi_dian_hua')" prop="signerPhone" :rules="rules.signerPhone">
                        <el-input v-model="form.partnerInfo.signerPhone" style="width: 100%"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item :label="$t('crm_contract_personPart_trial.fa_ren_xing_ming')" :rules="rules.legalPerson">
                    <el-input v-model="form.partnerInfo.legalPerson" :disabled="true" style="width: 100%"></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('crm_contract_personPart_trial.frsfzh')" :rules="rules.identityCard">
                    <el-input v-model="form.partnerInfo.identityCard" :disabled="true" style="width: 100%"></el-input>
                  </el-form-item>

                  <el-form-item :label="$t('crm_contract_personPart_trial.yi_fang_di_zhi')" :rules="rules.customerAddress">
                    <el-input type="textarea" v-model="form.partnerInfo.customerAddress" :disabled="true" style="width: 100%"></el-input>
                  </el-form-item>
                </div>
                <el-col :span="24">
                  <el-form-item :label="$t('crm_contract_personPart_trial.yfshdz')" prop="cdeliverAddressId" :rules="rules.cdeliverAddressId">
                    <div class="address-box" style="width: 100%">
                      <div class="address-btn" v-if="!form.partnerInfo.cdeliverAddressId" @click="changeAddress('PartyB')">+</div>
                      <div class="address-item" v-else>
                        <!-- <span class="address-default" v-if="form.partnerInfo.isDefault"
                            >{{$t('page_content_customer_default_address}}</span
                          > -->
                        <h3>
                          {{ $t('crm_contract_personPart_trial.yi_fang') }}:{{ form.partnerInfo.consigneeName }}（{{ $t('crm_contract_personPart_trial.shou') }}）
                          {{ form.partnerInfo.consigneePhone }}
                        </h3>
                        <p>{{ form.partnerInfo.detailAddress }}</p>
                        <span class="address-modify-btn" @click="changeAddress('PartyB')">{{ $t('Common.com_modify') }}</span>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="form-box">
        <p class="form-title">
          {{ $t('crm_contract_personPart_trial.htjbxx') }}
        </p>
        <el-form :model="form.baseInfo" ref="formBaseInfo" label-position="top">
          <div class="form-container">
            <el-row>
              <el-col :span="12" class="contract-a">
                <el-row :gutter="16">
                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.jiao_huo_ri_qi')" prop="deliveryDate" :rules="rules.deliveryDate">
                      <custom-date-picker
                        v-model="form.baseInfo.deliveryDate"
                        type="date"
                        align="right"
                        value-format="YYYY-MM-DD HH:mm:ss"
                        default-time="00:00:00"
                        :picker-options="pickerOptionDay"
                        style="width: 100%"
                      ></custom-date-picker>
                    </el-form-item>
                  </el-col>

                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.ying_yong_chang_jing')" prop="usageScene" :rules="rules.usageScene">
                      <custom-select v-model="form.baseInfo.usageScene" code="crm_contract_usage_scene" :placeholder="$t('Common.com_please_select')" width="100%"></custom-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="16">
                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.wu_liu_gong_si')" prop="logisticsCompanyCode" >
                      <custom-select
                        filterable
                        v-model="form.baseInfo.logisticsCompanyCode"
                        code="ice_logistics_company"
                        :placeholder="$t('Common.com_please_select')"
                        width="100%"
                        @change="onCompanyCodeChange"
                      ></custom-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.qi_ta_wu_liu_gong_si')" prop="logisticsCompanyName">
                      <el-input v-model="form.baseInfo.logisticsCompanyName"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="16">
                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.zhuan_zu_lin')"  prop="toRental" :rules="rules.toRental">
                      <el-radio-group v-model="form.baseInfo.toRental">
                        <el-radio :label="1">{{$t('Common.com_yes')}}</el-radio>
                        <el-radio :label="0">{{$t('Common.com_no')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item :label="$t('crm_contract_personPart_trial.jiao_fei')"  prop="isCharge" :rules="rules.isCharge">
                      <el-radio-group v-model="form.baseInfo.isCharge">
                        <el-radio :label="1">{{$t('Common.com_yes')}}</el-radio>
                        <el-radio :label="0">{{$t('Common.com_no')}}</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-col :span="24">
                  <el-col :span="24">
                    <el-form-item :label="$t('crm_contract_personPart_trial.xzsyyy')"   prop="rentalReasonCode"  >
                      <custom-select
                        v-model="form.baseInfo.rentalReasonCode"
                        code="crm_rental_reason"
                        :placeholder="$t('Common.com_please_select')"
                        width="100%"
                        @change="onrentalReasonCodeChange"
                      ></custom-select>
                    </el-form-item>
                    <el-form-item :label="$t('crm_contract_personPart_trial.shi_yong_yuan_yin')"  prop="rentalReason" :rules="(!form.baseInfo.toRental && !form.baseInfo.isCharge)?rules.rentalReason:[]" >
                      <el-input type="textarea" v-model="form.baseInfo.rentalReason" :placeholder="$t('crm_contract_personPart_trial.qxzhsrsyyy')" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-col>
              <el-col :span="12" class="contract-b">
                <el-row :gutter="16">
                  <el-row :gutter="16">
                    <el-col :span="16">
                      <el-form-item :label="$t('crm_contract_personPart_trial.ssxmqy')" prop="locationName" :rules="rules.locationName">
                        <el-input v-model="locationSiteName" style="width: 100%" :disabled="true"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="">
                        <span slot="label">&nbsp;&nbsp;&nbsp;&nbsp;</span>
                        <el-button style="width: 100%" @click="addProject">{{ $t('crm_contract_personPart_trial.xzxmqy') }}</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-col :span="24">
                    <el-form-item :label="$t('crm_contract_personPart_trial.shi_yong_di_zhi')" prop="address" :rules="rules.address">
                      <custom-address-select :placeholder="$t('Common.com_please_select')" v-model="form.baseInfo.address" ref="address" style="width: 100%"></custom-address-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item prop="useAddress" :rules="rules.useAddress">
                      <el-input type="textarea" v-model="form.baseInfo.useAddress" :placeholder="$t('crm_contract_personPart_trial.qsrxxdz')" style="width: 100%"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <div class="form-box">
        <div class="form-title">
          <span>{{ $t('crm_contract_personPart_trial.shou_hou_gong_si') }}</span>
        </div>
        <el-form :model="form.afterService" ref="formAfterService" label-position="top">
          <div class="form-container info-container">
            <el-row :gutter="16">
              <el-col :span="24">
                <el-form-item :label="$t('crm_contract_personPart_trial.shou_hou_gong_si')" prop="afterServiceId" :rules="rules.afterServiceId">
                  <!-- <custom-select
                      v-model="form.afterService.afterServiceId"
                      code="crm_contract_usage_scene"

                      @change="@change="serviceChange""
                      width="100%"
                    ></custom-select> -->
                  <custom-select
                    ref="afterServiceCompanySelect"
                    v-model="form.afterService.afterServiceId"
                    :auto="false"
                    url="partnerAllService"
                    :listener="`${form.afterService.afterServiceName}${isNeedRequest}`"
                    width="100%"
                    filterable
                    remote
                    :props="{ label: 'partnerNameCode', value: 'partnerOrgId' }"
                    :params="{ num: 50, keyword: form.afterService.afterServiceName }"
                    @change="onAfterServiceChange"
                    @clear="onAfterServiceClear"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('crm_contract_personPart_trial.shou_hou_fu_ze_ren')" prop="technicianName" :rules="rules.technicianName">
                  <!-- <el-input v-model="form.afterService.technicianName" style="width: 100%"></el-input> -->
                  <custom-select
                    v-model="form.afterService.technicianName"
                    :auto="false"
                    url="partnerContact"
                    :listener="`${form.afterService.afterServiceId || null}`"
                    width="100%"
                    filterable
                    allowCreate
                    defaultFirstOption
                    :isDefault="!!isNeedRequest"
                    :props="{ label: 'contactName', value: 'contactName' }"
                    :params="{ partnerOrgId: form.afterService.afterServiceId, contactType: 'coopcontact' }"
                    @change="technicianNameChange"
                  ></custom-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('crm_contract_personPart_trial.shfzrdh')" prop="technicianPhone" :rules="rules.technicianPhone">
                  <el-input v-model="form.afterService.technicianPhone" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item :label="$t('crm_contract_personPart_trial.shgsdz')" prop="sdeliverAddressId" :rules="rules.sdeliverAddressId">
                  <div class="address-box" style="width: 100%">
                    <div class="address-btn" v-if="!form.afterService.sdeliverAddressId" @click="changeAddress('service')">+</div>
                    <div class="address-item" v-else>
                      <!-- <span class="address-default" v-if="form.afterService.isDefault"
                          >{{ $t('page_content_customer_default_address}}</span
                        > -->
                      <h3>
                        {{ $t('crm_contract_personPart_trial.shou_hou_fang') }}{{ form.afterService.consigneeName }}（{{ $t('crm_contract_personPart_trial.shou') }}）
                        {{ form.afterService.consigneePhone }}
                      </h3>
                      <p>{{ form.afterService.detailAddress }}</p>
                      <span class="address-modify-btn" @click="changeAddress('service')">{{ $t('Common.com_modify') }}</span>
                    </div>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
      <!-- </el-form> -->
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveform">{{ $t('crm_contract_personPart_trial.xybxzsb') }}</el-button>
    </div>
    <!-- 选择地址 -->
    <contractManagement-chooseAddress-dialog
      v-if="dialogVisible"
      :data="dialogData"
      :model="dialogModel"
      @close="dialogVisible = false"
      @success="addAddress"
    ></contractManagement-chooseAddress-dialog>

    <!--添加银行卡-->
    <bankcard-address-dialog v-if="dialogVisible2" :data="dialogData2" :model="dialogModel2" @close="dialogVisible2 = false" @success="refreshBankcardList"></bankcard-address-dialog>
    <!-- 选择项目 -->
    <locationSite-select-dialog v-if="dialogVisible1" :model="dialogModel1" @close="dialogVisible1 = false" @success="onProjectChange"></locationSite-select-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import customAddressSelect from '@/components/customAddressSelect.vue';
import bankcardAddressDialog from '@/pages/crm/components/bankCardDialog.vue';
import contractManagementChooseAddressDialog from '@/pages/crm/components/chooseAddressDialog.vue';
import locationSiteSelectDialog from '@/pages/dms/components/location_site_select_dialog.vue';

export default {
  components: { contractManagementChooseAddressDialog, customAddressSelect, bankcardAddressDialog, locationSiteSelectDialog },
  props: {
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number], // 唯一标识
    isCopy: { type: Boolean, default: false },
  },

  // watch: {
  //   contractId() {
  //     this.getContractDetail();
  //   },
  // },
  inject: ['getContractInfo'],
  computed: {
    rules() {
      return {
        // baseInfo: {
        contractType: { required: true, message: this.$t('crm_contract_personPart_trial.qxzhtlx') }, // 合同类型，数据字典：crm_contract_type
        signingMethod: { required: true, message: this.$t('crm_contract_personPart_trial.qxzqdfs') }, // 签订方式，字典分组代码：signing_method
        customContractNo: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxsghth') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], // 手工合同号
        signingDate: { required: true, message: this.$t('crm_contract_personPart_trial.qxzqdrq') }, // 签订日期
        usageScene: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qxzyycj') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], // 使用场景，数据字典：crm_contract_usage_scene
        contractTempId: { required: true, message: this.$t('crm_contract_personPart_trial.qxzhtqdmb') }, // 合同模板id
        locationName: { required: true, message: this.$t('crm_contract_personPart_trial.qxzssxm') }, // 项目名称Id
        // schemeType: { required: true, message: '请选择合同方案' }, // 合同方案，数据字典：crm_scheme_contract_type
        deliveryDate: { required: true, message: this.$t('crm_contract_personPart_trial.qxzjhrq') }, // 交货日期
        address: { required: true, message: this.$t('crm_contract_personPart_trial.qxzsydz') }, // 使用地址
        useAddress: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qxzxxdz') },
          { max: 200, message: this.$t('Common.com_rules_length_max', [200]), },
        ], // 详细地址
        // },
        // partnerInfo: {
        // 甲方
        partyAName: { required: true, message: this.$t('crm_contract_personPart_trial.qxzjfsqdb') }, // 甲方授权代表
        salesman: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxywfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], // 业务负责人
        salesmanPhone: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qxzywfzrdh') },
          { validator: null, message: this.$t('crm_contract_personPart_trial.cdyz713gzf') },
        ], // 业务负责人电话
        // 账号
        partyADepositNumber: { required: true, message: this.$t('crm_contract_personPart_trial.qxzzh') }, // 甲方授权代表银行卡号码
        partyADepositName: { required: true, message: this.$t('crm_contract_personPart_trial.qxzyhmc') }, // 甲方授权代表银行卡开户名
        partyADepositBank: { required: true, message: this.$t('crm_contract_personPart_trial.qxzzhmc') }, // 甲方授权代表银行卡开户支行

        // 乙方
        customerId: [{ required: true, message: this.$t('crm_contract_personPart_trial.qtxyfsqdb') }], // 乙方授权代表
        projectContactName: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxyfxmfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], // 乙方项目负责人
        projectContactPhone: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxyfxmfzrlxdh') },
          { validator: null, message: this.$t('crm_contract_personPart_trial.cdyz713gzf') },
        ], // 联系电话

        signerName: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxyfsqdb') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], //  乙方授权代表
        signerPhone: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxyfsqlxdh') },
          { validator: null, message: this.$t('crm_contract_personPart_trial.cdyz713gzf') },
        ], // 乙方授权联系电话

        // bigCustomerName: { required: true, message: '请选择所属集团名称' }, // 所属集团名称
        // legalPerson: { required: true, message: '请选择法人' }, // 法人
        // identityCard: { required: true, message: '请选择法人身份证' }, // 法人身份证
        // registeredCapital: { required: true, message: '请选择注册资金' }, // 注册资金
        // customerAddress: { required: true, message: '请选择售后乙方地址' }, // 售后乙方地址
        cdeliverAddressId: { required: true, message: this.$t('crm_contract_personPart_trial.qxzshgsdz') }, // 售后公司地址
        // businessLicense: { required: true, message: '请选择营业执照' }, // 营业执照
        // },
        // afterService: {
        afterServiceId: { required: true, message: this.$t('crm_contract_personPart_trial.qxzshgs') }, // 售后公司Id
        // afterServiceName: { required: true, message: '请填写乙方授权联系电话' }, // 售后公司
        // technicianId: { required: true, message: '请填写乙方授权联系电话' }, // 售后负责人Id
        technicianName: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxshfzr') },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ], // 售后负责人
        technicianPhone: [
          { required: true, message: this.$t('crm_contract_personPart_trial.qtxshfzrdh') }, // 售后负责人电话
          { validator: null, message: this.$t('crm_contract_personPart_trial.cdyz713gzf') },
        ], // 售后负责人电话
        // technicianEmail: { required: true, message: '请填写售后负责人邮箱' }, // 售后负责人邮箱
        sdeliverAddressId: { required: true, message: this.$t('crm_contract_personPart_trial.qtxshgsdz') }, // 售后公司地址
        // sdeliverAddressVersion: { required: true, message: '请填写乙方授权联系电话' }, //
        // }
        // 新
        // logisticsCompanyCode: { required: true, message: '请选择物流公司' }, // 其它物流公司
        logisticsCompanyName: { required: true, message: this.$t('crm_contract_personPart_trial.qtxqtwlgs') }, // 其它物流公司
        toRental: { required: true, message: this.$t('crm_contract_personPart_trial.qxzzzl') }, // 转租赁
        isCharge: { required: true, message: this.$t('crm_contract_personPart_trial.qxzjf') }, // 缴费
        rentalReason: { required: true, message: this.$t('crm_contract_personPart_trial.qtxsyyy') }, // 试用原因
      };
    },
    contractInfo() {
      return this.getContractInfo();
    },
    locationSiteName() {
      return `${this.form.baseInfo.locationName}${this.form.baseInfo.siteName ? '/' : ''}${this.form.baseInfo.siteName}`;
    },
  },
  watch: {
    contractInfo: function () {
      this.setContractInfo();
    },
    // 乙方ID被清空时，主动请求一次下拉接口刷新列表（避免清空后无数据可选）
    'form.partnerInfo.customerId': function (val, oldVal) {
      if (!val && oldVal) {
        this.requestCustomerList();
      }
    },
    // 售后公司ID被清空时，主动请求一次下拉接口刷新列表（避免清空后无数据可选）
    'form.afterService.afterServiceId': function (val, oldVal) {
      if (!val && oldVal) {
        this.requestAfterServiceCompanyList();
      }
    },
  },
  data() {
    // 密码验证
    return {
      form: {
        baseInfo: {
          // contractType: '10', // 合同类型，数据字典：crm_contract_type
          signingMethod: '2', // 签订方式，字典分组代码：signing_method
          // schemeType: '', // 合同方案，数据字典：crm_scheme_contract_type

          // customContractNo: '', // 手工合同号
          deliveryDate: '', // 交货日期
          // signingDuration: '', // 签订时间
          locationId: '', // 项目名称Id
          locationName: '', // 项目名称
          siteId: '', // 项目区域名称Id
          siteName: '', // 项目区域Id
          // signingDate: '', // 签订日期
          usageScene: '', // 使用场景，数据字典：crm_contract_usage_scene
          address: [], // 使用地址
          useAddress: '', // 使用地点

          // contractTempId: '', // 模板id
          // econtractTitle: '', // 模板标题
          // tempContent: '', // 模板内容

          city: '', // 所属城市
          cityCode: '', // 所属城市代码
          province: '', // 所属省份
          provinceCode: '', // 所属省份代码
          country: '', // 所属国家
          countryCode: '', // 所属国家编码
          logisticsCompanyCode: '', // 物流公司
          logisticsCompanyName: '', // 其它物流公司
          toRental: 1, // 转租赁
          isCharge: 1, // 缴费
          rentalReasonCode: '', // 试用原因
          rentalReason: '', // 试用原因
        },
        partnerInfo: {
          partyAId: '', // 甲方授权代表ID"
          partyAName: '', // 甲方授权代表名称"
          partyACode: '', // 甲方授权编码
          partyANameCode: '', // 甲方授权编码名字
          salesman: '', // 业务负责人
          salesmanPhone: '', // 业务负责人电话
          salesmanId: '', // 业务负责人ID
          partyAAddress: '', // 授权代表地址
          partyADepositNumber: '', // 账号
          partyADepositName: '', // 银行名称
          partyADepositBank: '', // 支行名称
          partyABizId: '', // 甲方授权代表ID"

          customerId: '', // 乙方授权代表
          customerCode: '', // 乙方编码
          customerName: '', // 乙方名称
          partnerOrgId: '', // 乙方orgId
          // businessLicense: '', // 营业执照用于预览合同

          projectContactName: '', // 乙方项目负责人
          projectContactPhone: '', // 联系电话
          signerName: '', // 授权代表
          signerPhone: '', // 联系电话
          // identityCard: '', // 法人身份证号
          customerAddress: '', // 乙方地址
          // bigCustomerId: '', // 大客户Id
          // bigCustomerName: '', // 大客户名称

          // 地址id
          partnerId: '',
          // 新加的
          businessLicense: '', // 营业执照用于预览合同
          legalPerson: '', // 法人
          identityCard: '', // 法人身份证
          // registeredCapital: '', // 注册资金

          // 乙方地址
          cdeliverAddressId: '', // 收货id
          cdeliverAddressVersion: '', // 地址版本
          isDefault: '', // 是否默认
          consigneeName: '', // 收货人
          consigneePhone: '', // 收货人电话
          detailAddress: '', // 详细地址
        },
        afterService: {
          afterServiceId: '', // 售后公司Id
          afterServiceName: '', // 售后公司
          sdeliverAddressId: '', //
          sdeliverAddressVersion: '', //
          technicianId: '', // 售后负责人Id
          technicianName: '', // 售后负责人名称
          technicianPhone: '', // 售后负责人电话

          // 售后地址
          isDefault: '',
          consigneeName: '',
          consigneePhone: '',
          detailAddress: '',
          // 地址id
          partnerOrgId: '',
        },

        bizId: '', // 合同ID，编辑时必填
        // bizClass: '10', // 合同类型 数据字典 crm_contract_class_type
        operateFlag: '', // 操作的唯一标识，标识一次连续的操作

        // 合同列表类型
        contractClassType: [],
        contractClassTypeList: [],
      },
      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},
      dialogData: {},
      // 更新下拉
      projectListFlag: '0',
      edit: false,
      // 公司ID
      // contractId: '',
      partyAList: [],

      // 选择项目
      dialogVisible1: '',
      dialogModel1: {},

      // 选择收货地址
      dialogVisible2: false,
      dialogModel2: {},
      dialogData2: {},
      BankcardListFlag: '0',
      // 编辑就为false  新增为true 避免重复调用公司的覆盖问题
      isNeedRequest: '',

      // 乙方下拉：清空后需要补拉取一次下拉数据，避免下拉列表为空无法重新选择
      customerSelectRequesting: false,
      // 售后公司下拉：清空后需要补拉取一次下拉数据，避免下拉列表为空无法重新选择
      afterServiceSelectRequesting: false,
    };
  },
  mounted() {
    setTimeout(() => {
      this.setContractInfo();
    }, 300);
    if (this.$route.path.indexOf('edit') > -1) {
      this.edit = true;
    }
    this.formRule();
  },
  methods: {
    // 乙方下拉：补请求一次下拉接口（带简单去重），用于 customerId 被清空的场景
    requestCustomerList() {
      if (this.customerSelectRequesting) {
        return;
      }
      this.customerSelectRequesting = true;

      this.$nextTick(() => {
        setTimeout(() => {
          const selectRef = this.$refs.customerSelect;
          if (selectRef && typeof selectRef.getSelectList === 'function') {
            selectRef.getSelectList();
          }
          this.customerSelectRequesting = false;
        }, 50);
      });
    },
    onCustomerClear() {
      // 用户手动点清空乙方时，也补拉一次下拉数据
      this.requestCustomerList();
    },
    // 售后公司下拉：补请求一次下拉接口（带简单去重），用于 afterServiceId 被清空的场景
    requestAfterServiceCompanyList() {
      if (this.afterServiceSelectRequesting) {
        return;
      }
      this.afterServiceSelectRequesting = true;

      this.$nextTick(() => {
        setTimeout(() => {
          const selectRef = this.$refs.afterServiceCompanySelect;
          if (selectRef && typeof selectRef.getSelectList === 'function') {
            selectRef.getSelectList();
          }
          this.afterServiceSelectRequesting = false;
        }, 50);
      });
    },
    onAfterServiceClear() {
      // 用户手动点清空售后公司时，也补拉一次下拉数据
      this.requestAfterServiceCompanyList();
    },
    formRule: function () {
      this.rules.salesmanPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.projectContactPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.signerPhone[1].validator = this.$mobilePhoneValidator;
      this.rules.technicianPhone[1].validator = this.$mobilePhoneValidator;
    },
    getContractDetail: function () {
      if (!this.contractId) {
        // 获取乙方信息（租赁方） 新增才需要调用
        // this.getCustomerList();
        // 获取甲方信息（当前登录人所属组织）新增才需要调用
        this.getPartyA();
        return;
      }
      this.$getJSON(apis.trialOrderInfo, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {

        const data = res.data;
        // this.$setFormatData(this.form, data);
        this.$setFormatData(this.form.baseInfo, data);
        this.$setFormatData(this.form.partnerInfo, data,);
        this.$setFormatData(this.form.afterService, data);
        this.form.partnerInfo.partyANameCode = `${this.form.partnerInfo.partyACode}${this.form.partnerInfo.partyACode ? '/' : ''}${this.form.partnerInfo.partyAName}`;
        // 拷贝合同 手工合同号 签订日期重置
        if (this.isCopy) {
          this.form.baseInfo.customContractNo = '';
          this.form.baseInfo.signingDate = '';
          this.form.baseInfo.deliveryDate = '';
        }
        // 修改
        // 合同类型
        this.form.baseInfo.contractType = `${this.form.baseInfo.contractType}`;
        // 签订方式
        // this.form.baseInfo.signingMethod = `${data.signingMethod}`;
        // 因为没有电子合同先写死是纸质合同
        this.form.baseInfo.signingMethod = '2';
        // 应用场景改类型
        this.form.baseInfo.usageScene = `${data.usageScene}`;

        // this.form.partnerInfo.businessLicense = '123456789';
        // 乙方
        // this.form.partnerInfo.contactName = data.projectContactName; // 项目负责人"
        // this.form.partnerInfo.contactPhone = data.projectContactPhone; // 联系电话
        // 地址
        this.form.baseInfo.address = [];
        if (data.countryCode) {
          this.form.baseInfo.address.push(data.countryCode);
        }
        if (data.provinceCode) {
          this.form.baseInfo.address.push(data.provinceCode);
        }
        if (data.cityCode) {
          this.form.baseInfo.address.push(data.cityCode);
        }

        // 获取乙方信息（租赁方） 新增才需要调用
        // this.getCustomerList();
        // 获取甲方信息（当前登录人所属组织）新增才需要调用
        // this.getPartyA();
        // infoForm //基本信息
        // form // 甲方乙方
        // afterForm// 服务中心
        // leaseForm// 租赁方案
        // paymentForm// 首付款信息
        // contractForm//合同签订

        // 乙方地址 cdeliverAddress
        if (data.cdeliverAddress && Object.keys(data.cdeliverAddress).length !== 0) {
          // this.form.partnerInfo.deliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
          // this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
          // this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
          // this.form.partnerInfo.detailAddress = data.cdeliverAddress.detailAddress; // 详细街道地址

          this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
          this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
          this.form.partnerInfo.detailAddress = `${data.cdeliverAddress.country}${data.cdeliverAddress.province}${data.cdeliverAddress.city}${data.cdeliverAddress.detailAddress}`; // 详细地址
          // this.partyForm.version=data.cdeliverAddress. // 版本号
          this.form.partnerInfo.isDefault = data.cdeliverAddress.isDefault || ''; // 是否默认
          this.form.partnerInfo.cdeliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
          this.form.partnerInfo.cdeliverAddressVersion = data.cdeliverAddress.version; // 地址版本
          // 地址ID
          this.form.partnerInfo.partnerOrgId = data.customerId; //
        }
        // 售后  sdeliverAddress
        if (data.sdeliverAddress && Object.keys(data.sdeliverAddress).length !== 0) {
          // this.form.afterService.deliverAddressId = data.sdeliverAddress.deliverAddressId; // 地址ID
          // this.form.afterService.consigneeName = data.sdeliverAddress.consigneeName; // 收货人
          // this.form.afterService.consigneePhone = data.sdeliverAddress.consigneePhone; // 收货人电话
          // this.form.afterService.detailAddress = data.sdeliverAddress.detailAddress; // 详细街道地址

          this.form.afterService.sdeliverAddressId = data.sdeliverAddress.deliverAddressId; // 地址ID
          this.form.afterService.sdeliverAddressVersion = data.sdeliverAddress.version; // 地址版本
          this.form.afterService.consigneeName = data.sdeliverAddress.consigneeName; // 收货人
          this.form.afterService.consigneePhone = data.sdeliverAddress.consigneePhone; // 收货人电话
          this.form.afterService.detailAddress = `${data.sdeliverAddress.country}${data.sdeliverAddress.province}${data.sdeliverAddress.city}${data.sdeliverAddress.detailAddress}`; // 详细地址
          // this.partyForm.version= data.sdeliverAddress. // 版本号
          this.form.afterService.isDefault = data.sdeliverAddress.isDefault || ''; // 是否默认
          // 地址ID
          this.form.afterService.partnerOrgId = data.afterServiceId;
        }

        // 试用原因
        // if (this.form.baseInfo.rentalReason) {
        // this.form.baseInfo.rentalReasonCode=
        // }

      });
    },
    setContractInfo: function () {
      if (!this.contractId) {
        // 获取乙方信息（租赁方） 新增才需要调用
        // this.getCustomerList();
        // 获取甲方信息（当前登录人所属组织）新增才需要调用
        this.getPartyA();
        this.isNeedRequest = true;
        return;
      }

      const data = this.contractInfo;
      // this.$setFormatData(this.form, data);
      this.$setFormatData(this.form.baseInfo, data);
      this.$setFormatData(this.form.partnerInfo, data);
      this.$setFormatData(this.form.afterService, data);
      this.form.partnerInfo.partyANameCode = `${this.form.partnerInfo.partyACode}${this.form.partnerInfo.partyACode ? '/' : ''}${this.form.partnerInfo.partyAName}`;
      // 修改
      // 合同类型
      this.form.baseInfo.contractType = `${this.form.baseInfo.contractType}`;
      // 签订方式
      this.form.baseInfo.signingMethod = '2';

      // 应用场景改类型
      this.form.baseInfo.usageScene = `${data.usageScene}`;
      // 签订时长（月）
      // this.form.partnerInfo.businessLicense = '123456789';
      // 乙方
      // this.form.partnerInfo.contactName = data.projectContactName; // 项目负责人"
      // this.form.partnerInfo.contactPhone = data.projectContactPhone; // 联系电话
      // 地址
      this.form.baseInfo.address = [];
      if (data.countryCode) {
        this.form.baseInfo.address.push(data.countryCode);
      }
      if (data.provinceCode) {
        this.form.baseInfo.address.push(data.provinceCode);
      }
      if (data.cityCode) {
        this.form.baseInfo.address.push(data.cityCode);
      }

      // 获取乙方信息（租赁方） 新增才需要调用
      // this.getCustomerList();
      // 获取甲方信息（当前登录人所属组织）新增才需要调用
      // this.getPartyA();
      // infoForm //基本信息
      // form // 甲方乙方
      // afterForm// 服务中心
      // leaseForm// 租赁方案
      // paymentForm// 首付款信息
      // contractForm//合同签订
      // 地址ID
      this.form.partnerInfo.partnerOrgId = data.customerId; //
      // 地址ID
      this.form.afterService.partnerOrgId = data.afterServiceId;
      this.isNeedRequest = false;
      // 乙方地址 cdeliverAddress
      if (data.cdeliverAddress && Object.keys(data.cdeliverAddress).length !== 0) {
        // this.form.partnerInfo.deliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
        // this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
        // this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
        // this.form.partnerInfo.detailAddress = data.cdeliverAddress.detailAddress; // 详细街道地址

        this.form.partnerInfo.consigneeName = data.cdeliverAddress.consigneeName; // 收货人
        this.form.partnerInfo.consigneePhone = data.cdeliverAddress.consigneePhone; // 收货人电话
        this.form.partnerInfo.detailAddress = `${data.cdeliverAddress.country}${data.cdeliverAddress.province}${data.cdeliverAddress.city}${data.cdeliverAddress.detailAddress}`; // 详细地址
        // this.partyForm.version=data.cdeliverAddress. // 版本号
        this.form.partnerInfo.isDefault = data.cdeliverAddress.isDefault || ''; // 是否默认
        this.form.partnerInfo.cdeliverAddressId = data.cdeliverAddress.deliverAddressId; // 地址ID
        this.form.partnerInfo.cdeliverAddressVersion = data.cdeliverAddress.version; // 地址版本
      }
      // 售后  sdeliverAddress
      if (data.sdeliverAddress && Object.keys(data.sdeliverAddress).length !== 0) {
        // this.form.afterService.deliverAddressId = data.sdeliverAddress.deliverAddressId; // 地址ID
        // this.form.afterService.consigneeName = data.sdeliverAddress.consigneeName; // 收货人
        // this.form.afterService.consigneePhone = data.sdeliverAddress.consigneePhone; // 收货人电话
        // this.form.afterService.detailAddress = data.sdeliverAddress.detailAddress; // 详细街道地址

        this.form.afterService.sdeliverAddressId = data.sdeliverAddress.deliverAddressId; // 地址ID
        this.form.afterService.sdeliverAddressVersion = data.sdeliverAddress.version; // 地址版本
        this.form.afterService.consigneeName = data.sdeliverAddress.consigneeName; // 收货人
        this.form.afterService.consigneePhone = data.sdeliverAddress.consigneePhone; // 收货人电话
        this.form.afterService.detailAddress = `${data.sdeliverAddress.country}${data.sdeliverAddress.province}${data.sdeliverAddress.city}${data.sdeliverAddress.detailAddress}`; // 详细地址
        // this.partyForm.version= data.sdeliverAddress. // 版本号
        this.form.afterService.isDefault = data.sdeliverAddress.isDefault || ''; // 是否默认
      }
    },

    // 合同类型下拉字典
    changeAddress: function (type) {
      if (type === 'PartyB') {
        if (this.form.partnerInfo.partnerOrgId) {
          this.dialogVisible = true;
          this.dialogModel.title = this.$t('crm_contract_personPart_trial.xzyfsqdb');
          this.dialogModel.data = {
            // bizId: this.form.partnerInfo.bizId,

            // partnerId: this.form.partnerInfo.bizId,
            partnerOrgId: this.form.partnerInfo.partnerOrgId,

            type: 'PartyB',
          };
        } else {
          this.$message({
            message: this.$t('crm_contract_personPart_trial.qxxzyfsqdb'),
            type: 'error',
          });
        }
      } else {
        // service
        if (this.form.afterService.partnerOrgId) {
          this.dialogVisible = true;
          this.dialogModel.title = this.$t('crm_contract_personPart_trial.xzshshdz');
          this.dialogModel.data = {
            partnerOrgId: this.form.afterService.partnerOrgId,
            type: 'service',
          };
        } else {
          this.$message({
            message: this.$t('crm_contract_personPart_trial.qxxzshgs'),
            type: 'error',
          });
        }
      }
    },
    addAddress: function (arg) {
      const item = arg[0];
      if (this.dialogModel.data.type === 'PartyB') {
        // deliverAddressId
        this.form.partnerInfo.consigneeName = item.consigneeName; // 收货人
        this.form.partnerInfo.consigneePhone = item.consigneePhone; // 收货人电话
        this.form.partnerInfo.detailAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
        // this.partyForm.version=item. // 版本号
        this.form.partnerInfo.isDefault = item.isDefault || ''; // 是否默认
        this.form.partnerInfo.cdeliverAddressId = item.deliverAddressId; // 地址ID
        this.form.partnerInfo.cdeliverAddressVersion = item.version; // 地址版本
      } else {
        this.form.afterService.sdeliverAddressId = item.deliverAddressId; // 地址ID
        this.form.afterService.sdeliverAddressVersion = item.version; // 地址版本
        this.form.afterService.consigneeName = item.consigneeName; // 收货人
        this.form.afterService.consigneePhone = item.consigneePhone; // 收货人电话
        this.form.afterService.detailAddress = `${item.country}${item.province}${item.city}${item.detailAddress}`; // 详细地址
        // this.partyForm.version=item. // 版本号
        this.form.afterService.isDefault = item.isDefault || ''; // 是否默认
      }
    },
    // 选择项目
    addProject: function () {
      if (!this.form.partnerInfo.customerId) {
        this.$message({
          message: this.$t('crm_contract_personPart_trial.qnxxzyf'),
          type: 'error',
        });
        return;
      }
      this.dialogModel1.title = this.$t('crm_contract_personPart_trial.xzxmqyo', [this.locationSiteName]);
      this.dialogModel1.type = 'add';
      this.dialogModel1.row = {
        orgId: this.form.partnerInfo.customerId,
        orgName: this.form.partnerInfo.customerName,
        locationId: this.form.baseInfo.locationId, // 项目名称Id
        locationName: this.form.baseInfo.locationName, // 项目名称
        siteId: this.form.baseInfo.siteId, // 项目区域名称Id
        siteName: this.form.baseInfo.siteName, // 项目区域Id
      };
      this.dialogVisible1 = true;
    },
    // 刷新项目下拉列表
    refreshProjectList: function () {
      this.projectListFlag += 1;
    },
    // 添加银行卡
    addBankCard: function () {
      this.dialogVisible2 = true;
      this.dialogModel2.title = this.$t('crm_contract_personPart_trial.tjyhkxx');
      this.dialogData2 = '';
    },
    // 刷新银行卡下拉列表
    refreshBankcardList: function () {
      this.BankcardListFlag += 1;
    },
    // 物流公司
    onCompanyCodeChange(row) {
      this.form.baseInfo.logisticsCompanyName = row.value ? row.name : '';
    },
    // 试用原因
    onrentalReasonCodeChange(row) {
      this.form.baseInfo.rentalReason = row.value ? row.name : '';
    },
    // 取消
    onCancel: function () {
      // this.jump('/contract/management', { refresh: true }, true);
      this.$emit('cancelJump');
    },
    // 保存甲方乙方
    saveform: function () {
      // 检查地址是否已选择
      const addressValue = this.$refs.address.value;
      if (!addressValue || (Array.isArray(addressValue) && addressValue.length === 0)) {
        this.$message.error(this.$t('crm_contract_personPart_trial.qxzsydz'));
        return;
      }
      // 赋值 国家城市镇区
      const addressMsg = this.$refs.address.getAddressMsg();
      this.$setFormatData(this.form.baseInfo, addressMsg);
      this.$refs.formPartnerInfo.validate((valid1) => {
        if (!valid1) {
          return;
        }
        this.$refs.formBaseInfo.validate((valid2) => {
          if (!valid2) {
            return;
          }
          this.$refs.formAfterService.validate((valid3) => {
            if (!valid3) {
              return;
            }
            this.form.operateFlag = this.operateFlag;
            this.form.bizId = this.contractId;
            // this.form.bizClass = this.form.baseInfo.contractType;

            if (this.isCopy) {
              this.$postJSON(apis.trialOrderCopy, this.form).then((res) => {
                this.$message({
                  message: this.$t('Common.com_add_success'),
                  type: 'success',
                });
                this.$emit('syncContractId', res.data);
                this.$emit('success', 2);
              });
            } else if (this.contractId) {
              this.$postJSON(apis.trialOrderUpdate, this.form).then((res) => {
                this.$message({
                  message: this.$t('Common.com_save_success'),
                  type: 'success',
                });
                this.$emit('syncContractId', res.data);
                this.$emit('success', 2);
              });
            } else {
              this.$postJSON(apis.trialOrderAdd, this.form).then((res) => {
                this.$message({
                  message: this.$t('Common.com_add_success'),
                  type: 'success',
                });
                this.$emit('syncContractId', res.data);
                this.$emit('success', 2);
              });
            }
          });
        });
      });
    },
    partyBChange: function (item) {
      if (item) {
        // this.form.customerId = item.contactName || ''; // 乙方授权代表id
        // this.form.customerName = item.contactName || ''; // 乙方授权代表名称 自用
        this.form.partnerInfo.customerCode = item.partnerCode; // code 授权代表code
        this.form.partnerInfo.customerName = item.partnerName; // name 授权代表name

        // this.form.partnerInfo.projectContactName = item.busLeaderName || ''; // 项目负责人"
        // this.form.partnerInfo.projectContactPhone = item.busLeaderPhone || ''; // 联系电话
        // 下拉要清空
        this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = ''; // 联系电话

        this.form.partnerInfo.signerName = item.contactName || ''; // 授权代表

        this.form.partnerInfo.signerPhone = item.contactPhone || ''; // 联系电话

        // this.form.partnerInfo.identityCard = item.identityCard || ''; // 法人身份证号
        this.form.partnerInfo.customerAddress = item.address || ''; // 乙方地址

        // this.form.partnerInfo.bigCustomerId = item.parentId || ''; // 上级大客户ID
        // this.form.partnerInfo.bigCustomerName = item.parentName || ''; // 上级大客户名称

        // 地址ID
        // this.form.partnerInfo.bizId = item.partnerOrgId; // 乙方地址id
        this.form.partnerInfo.partnerOrgId = item.partnerOrgId; // 乙方地址id

        // 法人姓名 身份证
        this.form.partnerInfo.legalPerson = item.legalPerson;
        this.form.partnerInfo.identityCard = item.legalPersonIdentity;
        // 默认地址
        // if (item.partnerDeliverAddress && Object.keys(item.partnerDeliverAddress).length !== 0) {
        //   this.form.deliverAddressId = item.partnerDeliverAddress.deliverAddressId; // 地址ID
        //   this.form.consigneeName = item.partnerDeliverAddress.consigneeName;// 收货人
        //   this.form.consigneePhone = item.partnerDeliverAddress.consigneePhone;// 收货人电话
        //   this.form.detailAddress = item.partnerDeliverAddress.detailAddress;// 详细街道地址
        // }

        // 默认地址
        if (item.partnerDeliverAddress && Object.keys(item.partnerDeliverAddress).length !== 0) {
          this.form.partnerInfo.cdeliverAddressId = item.partnerDeliverAddress.deliverAddressId; // 地址ID
          this.form.partnerInfo.cdeliverAddressVersion = item.partnerDeliverAddress.version; // 地址版本
          this.form.partnerInfo.consigneeName = item.partnerDeliverAddress.consigneeName; // 收货人
          this.form.partnerInfo.consigneePhone = item.partnerDeliverAddress.consigneePhone; // 收货人电话
          this.form.partnerInfo.detailAddress = `${item.partnerDeliverAddress.country}${item.partnerDeliverAddress.province}${item.partnerDeliverAddress.city}${item.partnerDeliverAddress.detailAddress}`; // 详细街道地址
        } else {
          this.form.partnerInfo.cdeliverAddressId = ''; // 地址ID
          this.form.partnerInfo.cdeliverAddressVersion = item.cdeliverAddressVersion; // 地址版本
          this.form.partnerInfo.consigneeName = ''; // 收货人
          this.form.partnerInfo.consigneePhone = ''; // 收货人电话
          this.form.partnerInfo.detailAddress = ''; // 详细街道地址
        }
      } else {
        this.form.partnerInfo.customerCode = ''; // code 授权代表code
        this.form.partnerInfo.customerName = ''; // name 授权代表name

        this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = ''; // 联系电话

        this.form.partnerInfo.signerName = ''; // 授权代表

        this.form.partnerInfo.signerPhone = ''; // 联系电话

        // this.form.partnerInfo.identityCard = item.identityCard || ''; // 法人身份证号
        this.form.partnerInfo.customerAddress = ''; // 乙方地址

        // this.form.partnerInfo.bigCustomerId = ''; // 上级大客户ID
        // this.form.partnerInfo.bigCustomerName = ''; // 上级大客户名称

        // 地址ID
        // this.form.partnerInfo.bizId = item.partnerOrgId; // 乙方地址id
        this.form.partnerInfo.partnerOrgId = ''; // 乙方地址id

        // 法人姓名 身份证
        this.form.partnerInfo.legalPerson = '';
        this.form.partnerInfo.identityCard = '';
        this.form.partnerInfo.cdeliverAddressId = ''; // 地址ID
        this.form.partnerInfo.cdeliverAddressVersion = ''; // 地址版本
        this.form.partnerInfo.consigneeName = ''; // 收货人
        this.form.partnerInfo.consigneePhone = ''; // 收货人电话
        this.form.partnerInfo.detailAddress = ''; // 详细街道地址
      }
      this.onProjectChange();
    },

    // 获取甲方信息（当前登录人所属组织）
    getPartyA: function () {
      this.$getJSON(apis.partnerGetPartyA).then((res) => {
        // this.projectList = res.data;
        // this.$setFormatData(this.form.partnerInfo, res.data);
        this.form.partnerInfo.partyAId = res.data.partnerOrgId; // 甲方授权代表
        this.form.partnerInfo.partyABizId = res.data.partnerId; // 甲方授权代表biBizId
        this.form.partnerInfo.partyAName = res.data.partnerName;
        this.form.partnerInfo.partyACode = res.data.partnerCode;
        this.form.partnerInfo.partyANameCode = `${this.form.partnerInfo.partyACode}${this.form.partnerInfo.partyACode ? '/' : ''}${this.form.partnerInfo.partyAName}`;
        this.form.partnerInfo.businessLicense = res.data.businessLicense;
        // this.form.partnerInfo.salesman = res.data.contactName || ''; // 甲方项目负责人
        // this.form.partnerInfo.salesman = res.data.contactName || ''; // 甲方项目负责人
        // this.form.partnerInfo.salesmanPhone = res.data.contactPhone || ''; // 联系电话
        this.form.partnerInfo.partyAAddress = res.data.address || '';

        this.form.partnerInfo.partyADepositNumber = res.data.partyADepositNumber || ''; // 甲方授权代表银行卡号码
        this.form.partnerInfo.partyADepositName = res.data.partyADepositName || ''; // 甲方授权代表银行卡开户名
        this.form.partnerInfo.partyADepositBank = res.data.partyADepositBank || ''; // 甲方授权代表银行卡开户支行
      });
    },
    // 甲方业务负责人
    salesmanChange(item) {
      if (item && (this.isNeedRequest || this.form.partnerInfo.salesmanId !== item.userId)) {
        this.form.partnerInfo.salesman = item.realName || ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = item.mobile || ''; // 联系电话
        this.form.partnerInfo.salesmanId = item.userId || ''; // id
      } else {
        this.form.partnerInfo.salesman = !this.isNeedRequest ? this.form.partnerInfo.salesman : ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = !this.isNeedRequest ? this.form.partnerInfo.salesmanPhone : ''; // 联系电话
        this.form.partnerInfo.salesmanId = !this.isNeedRequest ? this.form.partnerInfo.salesmanId : '';// id
      }
    },
    // salesman匹配不上
    getSalesmanList(list) {
      if (!list.some(item => item.realName === this.form.partnerInfo.salesman)) {
        this.form.partnerInfo.salesman = ''; // 甲方项目负责人
        this.form.partnerInfo.salesmanPhone = ''; // 联系电话
        this.form.partnerInfo.salesmanId = ''; // id
      }
    },
    // 乙方项目负责人
    projectContactNameChange(item) {
      if (item && (this.isNeedRequest || this.form.partnerInfo.projectContactPhone !== item.mobilePhone)) {
        this.form.partnerInfo.projectContactName = item.contactName || ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = item.mobilePhone || ''; // 联系电话
      } else {
        // this.form.partnerInfo.projectContactName = ''; // 项目负责人"
        this.form.partnerInfo.projectContactPhone = !this.isNeedRequest ? this.form.partnerInfo.projectContactPhone : ''; // 联系电话
      }
    },
    // 售后负责人
    technicianNameChange(item) {
      if (item) {
        this.form.afterService.technicianName = item.contactName || ''; // 售后负责人名称
        this.form.afterService.technicianPhone = item.mobilePhone || ''; // 售后负责人电话
      } else {
        // this.form.afterService.technicianName = ''; // 售后负责人名称
        this.form.afterService.technicianPhone = !this.isNeedRequest ? this.form.afterService.technicianPhone : ''; // 售后负责人电话
      }
    },
    // 模板下拉
    // onEcontractTemp: function (item) {
    //   // console.log(item);
    //   this.form.baseInfo.econtractTitle = item.title;
    //   // this.form.baseInfo.tempContent = item.tempContent;
    // },
    onProjectChange: function (item) {
      if (item && Object.keys(item).length) {
        this.form.baseInfo.locationName = item.locationName;
        this.form.baseInfo.locationId = item.locationId;
        this.form.baseInfo.siteName = item.siteName;
        this.form.baseInfo.siteId = item.siteId;
        // if (this.form.baseInfo.address.length === 0) {
        // this.form.baseInfo.address = [];
        // this.form.baseInfo.useAddress = '';
        // 只有为空才带出来
        if (item.countryCode) {
          this.form.baseInfo.address = [];
          this.form.baseInfo.address.push(item.countryCode);
        }
        if (item.provinceCode) {
          this.form.baseInfo.address.push(item.provinceCode);
        }
        if (item.cityCode) {
          this.form.baseInfo.address.push(item.cityCode);
        }
        if (item.detailAddress) {
          this.form.baseInfo.useAddress = item.detailAddress;
        }
        // }
      } else {
        this.form.baseInfo.locationName = '';
        this.form.baseInfo.locationId = '';
        this.form.baseInfo.siteId = '';
        this.form.baseInfo.siteName = '';
        this.form.baseInfo.address = [];
        this.form.baseInfo.useAddress = '';
      }
    },

    // 银行下拉
    onDepositNumber: function (item) {
      this.form.partnerInfo.partyADepositName = item.depositName;
      this.form.partnerInfo.partyADepositBank = item.depositBank;
    },
    onGetBankList: function (list) {
      const defaultItem = list.find(i => i.isDefault) || [];
      if (Object.keys(defaultItem).length) {
        this.form.partnerInfo.partyADepositNumber = this.form.partnerInfo.partyADepositNumber || defaultItem.depositNumber;
        this.form.partnerInfo.partyADepositName = this.form.partnerInfo.partyADepositName || defaultItem.depositName;
        this.form.partnerInfo.partyADepositBank = this.form.partnerInfo.partyADepositBank || defaultItem.depositBank;
      }
    },
    // onAfterServiceChange: function (item) {
    //   this.form.afterService.sdeliverAddressVersion = item.sdeliverAddressVersion;
    // },

    // 售后公司
    onAfterServiceChange: function (item) {
      if (item) {
        // this.afterForm.afterServiceId = item.partnerOrgId || ''; // 售后公司Id
        this.form.afterService.afterServiceName = item.partnerName || ''; // 售后公司
        // this.form.afterService.afterServiceSurcharge = item; // 售后附加费
        // this.form.afterService.technicianId = item.contactId || ''; // 售后负责人Id
        // 重置
        this.form.afterService.technicianName = ''; // 售后负责人名称
        this.form.afterService.technicianPhone = ''; // 售后负责人电话
        // this.form.afterService.technicianEmail = item.technicianEmail || ''; // 售后负责人电话

        // 地址ID
        // this.form.afterService.bizId = item.partnerOrgId;
        this.form.afterService.partnerOrgId = item.partnerOrgId;
        // 默认地址
        if (item.partnerDeliverAddress && Object.keys(item.partnerDeliverAddress).length !== 0) {
          this.form.afterService.sdeliverAddressId = item.partnerDeliverAddress.deliverAddressId; // 地址ID
          this.form.afterService.sdeliverAddressVersion = item.partnerDeliverAddress.version;
          this.form.afterService.consigneeName = item.partnerDeliverAddress.consigneeName; // 收货人
          this.form.afterService.consigneePhone = item.partnerDeliverAddress.consigneePhone; // 收货人电话
          this.form.afterService.detailAddress = `${item.partnerDeliverAddress.country}${item.partnerDeliverAddress.province}${item.partnerDeliverAddress.city}${item.partnerDeliverAddress.detailAddress}`; // 详细街道地
        } else {
          this.form.afterService.sdeliverAddressId = ''; // 地址ID
          this.form.afterService.sdeliverAddressVersion = '';
          this.form.afterService.consigneeName = ''; // 收货人
          this.form.afterService.consigneePhone = ''; // 收货人电话
          this.form.afterService.detailAddress = ''; // 详细街道地址
        }
      } else {
        // 清空
        this.form.afterService.afterServiceName = ''; // 售后公司
        // this.form.afterService.afterServiceSurcharge = item; // 售后附加费
        this.form.afterService.technicianId = ''; // 售后负责人Id
        this.form.afterService.technicianName = ''; // 售后负责人名称
        this.form.afterService.technicianPhone = ''; // 售后负责人电话
        // this.form.afterService.technicianEmail = item.technicianEmail || ''; // 售后负责人电话

        // 地址ID
        // this.form.afterService.bizId = item.partnerOrgId;
        this.form.afterService.partnerOrgId = '';
        this.form.afterService.sdeliverAddressId = ''; // 地址ID
        this.form.afterService.sdeliverAddressVersion = '';
        this.form.afterService.consigneeName = ''; // 收货人
        this.form.afterService.consigneePhone = ''; // 收货人电话
        this.form.afterService.detailAddress = ''; // 详细街道地址

        // 售后公司ID被清空后，补请求一次下拉接口，便于重新选择
        this.requestAfterServiceCompanyList();
      }
    },

    // 预览模板
    previewTemplate: function () {
      // console.log(this.form.baseInfo.contractTempId);
      if (this.form.baseInfo.contractTempId) {
        this.$postJSON(apis.crmBestsginTemplatePreview, {
          tid: this.form.baseInfo.contractTempId,
          // account: '330106199508016666'
          account: this.form.partnerInfo.businessLicense,
        }).then((res) => {
          // window.open(res.data.url);

          this.jumpNewTab(res.data.url);
        });
      } else {
        this.$message({
          message: this.$t('crm_contract_personPart_trial.qxxzhtmb'),
          type: 'error',
        });
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-party {
  // padding:0px !important;
  padding: 0 24px;
  .form-box {
    margin-top: 35px;
    position: relative;
    width: 100%;
    border: 1px solid rgba(13, 154, 224, 0.3);
    padding: 35px 0 32px;
    .form-title {
      font-size: 12px;
      font-weight: 600;
      color: rgba(13, 154, 224, 1);
      line-height: 20px;
      height: 20px;
      position: absolute;
      top: -10px;
      left: 16px;
      background: #ffffff;
      padding: 0 10px;
    }
    .form-container {
      padding: 0 24px;
      width: 1100px;
      .party-a,
      .party-b,
      .contract-a,
      .contract-b {
        padding: 0 24px;
        width: 440px;
        box-sizing: content-box;
      }
      .party-b,
      .contract-b {
        border-left: 1px solid #eef2f8;
      }
      // 甲乙方信息
      .address-box {
        > h3 {
          color: #000;
          padding-bottom: 16px;
          line-height: 24px;
        }
        // .address-btn {
        //   border: 4px dashed #00afff;
        //   position: relative;
        //   height: 136px;
        //   line-height: 136px;
        //   text-align: center;
        //   font-size: 60px;
        //   color: rgba(0, 0, 0, 0.45);
        // }
        // .address-item {
        //   border: 4px dashed #00afff;
        //   position: relative;
        //   padding: 10px 0 0 10px;
        //   h3 {
        //     line-height: 40px;
        //     height: 40px;
        //     font-size: 14px;
        //     color: #1e1e1e;
        //     border-bottom: 1px solid #efefef;
        //   }
        //   p {
        //     font-size: 12px;
        //     line-height: 17px;
        //     color: #666;
        //     padding-top: 10px;
        //     height: 78px;
        //   }
        .address-modify-btn {
          position: absolute;
          bottom: 10px;
          font-size: 12px;
          color: #f33a73;
          cursor: pointer;
        }
        //   .address-default {
        //     position: absolute;
        //     top: 0;
        //     right: 0;
        //     font-size: 12px;
        //     color: #fff;
        //     padding: 0 13px;
        //     background: rgba(0, 0, 0, 0.19);
        //     border-radius: 0px 0px 0px 100px;
        //   }
        // }
      }
    }
    .info-container {
      width: 668px;
      padding: 0 24px;
      box-sizing: content-box;
    }
  }
}
</style>
